import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

export type PostExpressOrderRequest = {
    list_no: string;
    c_name: string;
    c_charge_name: string;
    c_dept_name: string;
    c_mobile: string;
    kind: string;
    pay_gbn: string;
    doc: string;
    sfast: string;
    item_type: string;
    s_start: string;
    start_telno: string;
    dept_name: string;
    charge_name: string;
    start_sido: string;
    start_gugun: string;
    start_dong: string;
    start_location: string;
    s_dest: string;
    dest_telno: string;
    dest_dept: string;
    dest_charge: string;
    dest_sido: string;
    dest_gugun: string;
    dest_dong: string;
    dest_location: string;
    reason_desc: string;
    kind_etc: string;
    dtime: string;
};

interface PostExpressOrderResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const usePostConsoleExpressOrder = (): UseMutationResult<PostExpressOrderResponse, Error, PostExpressOrderRequest, unknown> => {
    const queryClient = useQueryClient();
    return useMutation<PostExpressOrderResponse, Error, PostExpressOrderRequest>({
        mutationFn: async (data: PostExpressOrderRequest) => {
            const url = enum_api_uri.post_console_express_order.replace(":list_no", data.list_no);

            const response = await axiosInstance.post(url, data);
            return response.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleExpressOrderDetail"] });
            // successCallback?.(data);
        },
    });
};
